//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import CallCallbackEnums from "../../enums/CallbackEnums.js";
import CallBackService from "../CallbackService.js";

const CallCallbackActionHandler = class CallCallbackActionHandler {
  async handle(action, store) {
    if (action.callbackType == CallCallbackEnums.RESULTS) {
      store.state.Results.isFlowComplete = action.isEndOfFlow;
      action.event = store.state.Results;
    }
    CallBackService.handleCallback(action.callbackType, action.event);
  }
};

export default CallCallbackActionHandler;
